import { useState } from "react";
import { FAQ_IMAGE } from "../../../utils/constants";
import { getCloudinaryImageUrl } from "../../../utils/getCloudinaryImageUrl";
import Button from "../Common/Button";
import { useNavigate } from "react-router-dom";

export default function MixMastersFAQ() {
  const [openIndex, setOpenIndex] = useState(null);
  const navigate = useNavigate();

  const faqs = [
    {
      question: "What Types Of Construction Projects Do You Handle?",
      answer:
        "MixMasters concrete solutions support residential, commercial, industrial, and infrastructure projects. Our mixes are engineered for foundations, flooring, pavements, vertical structures, and decorative concrete applications.",
    },
    {
      question: "How Do I Choose The Right Concrete Mix For My Project?",
      answer:
        "Each MixMasters product is designed for a specific purpose. For example, PileMix is ideal for deep foundations, RoofMix for slabs and roofs, and RunwayMix for roads and highways.",
    },
    {
      question: "Do You Provide Concrete For Deep Foundations?",
      answer:
        "Yes. PileMix and RaftMix are specially engineered for deep foundation piling and mass raft foundations, ensuring superior load-bearing strength and long-term structural stability.",
    },
    {
      question: "Which Concrete Mix Is Best For Flooring?",
      answer:
        "FloorMix is designed specifically for flooring applications. It provides a smooth surface finish, strong wear resistance, and excellent crack control for residential and commercial spaces.",
    },
    {
      question: "Do You Offer High-Strength Concrete For Heavy Structures?",
      answer:
        "Yes. DynaMix is a high-performance concrete designed for demanding structures such as bridges, skyscrapers, and industrial projects where maximum strength and durability are required.",
    },
    {
      question: "Is There A Concrete Mix For Roads And Pavements?",
      answer:
        "RunwayMix is engineered for roads, highways, and airport runways. It offers high load-bearing strength, durability, and resistance to heavy traffic and environmental stress.",
    },
    {
      question: "Do You Provide Fast-Setting Concrete For Quick Projects?",
      answer:
        "Yes. KwikMix is a rapid-strength concrete that sets quickly and develops early strength, making it ideal for repairs, roadworks, and time-sensitive construction projects.",
    },
  ];

  return (
    <div className="w-full bg-white pt-10 lg:pt-16 px-4 sm:px-6 md:px-8 lg:px-10">
      <style>{`
        .faq-item { transition: background 0.2s; }
        .faq-answer { overflow: hidden; transition: max-height 0.35s ease, opacity 0.3s ease; }
      `}</style>

      <div className="">
        {/* Header row */}
        <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4 mb-8 lg:mb-10">
          <div>
            <p
              className="font-semibold mb-3"
              style={{
                color: "#c020d0",
                fontSize: "0.7rem",
                letterSpacing: "0.18em",
                textTransform: "uppercase",
              }}
            >
              [HELPFUL ANSWERS]
            </p>
            <h2 className="text-2xl md:text-3xl lg:text-4xl xl:text-5xl tracking-wider text-[#041122] font-heading leading-relaxed   font-semibold">
              Frequently Asked Questions
              <br className="hidden sm:block" />
              <span className="sm:hidden"> </span>
              About Our Services
            </h2>
          </div>

          <div className="flex sm:justify-end items-start">
            <Button onClick={() => navigate(`/contact`)} text={"Contact us"} />
          </div>
        </div>

        {/* Main row — stacks on mobile, side by side on desktop */}
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_auto] flex-col lg:flex-row gap-6 lg:gap-8 ">
          {/* LEFT — Accordion */}
          <div className="w-full">
            {faqs.map((faq, i) => {
              const isOpen = openIndex === i;
              return (
                <div
                  key={i}
                  className="faq-item rounded-xl mb-3 cursor-pointer"
                  style={{
                    background: isOpen ? "#fff5ff" : "#f5f5f7",
                    border: isOpen
                      ? "1.5px solid #e8a0f8"
                      : "1.5px solid transparent",
                  }}
                  onClick={() => setOpenIndex(isOpen ? -1 : i)}
                >
                  {/* Question row */}
                  <div className="flex items-center justify-between px-5 py-4">
                    <span
                      className="font-semibold font-heading text-sm pr-4"
                      style={{ color: isOpen ? "#c020d0" : "#1a1a2e" }}
                    >
                      {faq.question}
                    </span>
                    <span
                      className="flex-shrink-0 w-7 h-7 rounded-full flex items-center justify-center font-bold"
                      style={{
                        background: isOpen ? "#f3d0ff" : "#e8e8ee",
                        color: isOpen ? "#c020d0" : "#888",
                        fontSize: "1.1rem",
                        transition: "background 0.2s, color 0.2s",
                      }}
                    >
                      {isOpen ? "−" : "+"}
                    </span>
                  </div>

                  {/* Answer */}
                  <div
                    className="faq-answer"
                    style={{
                      maxHeight: isOpen ? "200px" : "0px",
                      opacity: isOpen ? 1 : 0,
                    }}
                  >
                    <p className="px-5 pb-5 text-gray-500 text-sm leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>

          {/* RIGHT — Image */}
          <div className="rounded-2xl flex items-end overflow-hidden w-full h-[420px] lg:h-[520px] lg:w-[500px] xl:w-[620px] justify-self-end">
            <img
              src={getCloudinaryImageUrl(FAQ_IMAGE, { width: 600 })}
              alt="FAQ"
              className="w-full h-full object-cover object-bottom"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
